import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import ImagePage from "@app/components/pageTypes/ImagePage/ImagePage"
import AnimatedRoute, { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useNewPassword } from "@app/store/service/connectorService"
import { useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useState } from "react"
import { useForm } from "react-hook-form"
import PasswordValidation from "@app/components/Account/PasswordValidation/PasswordValidation.jsx"

const NewPassword = () => {
	const resetPasswordToken = useSelector(state => state.core.resetPasswordToken)
	const { replace } = useCustomNavigation()
	const { sm, md } = useViewport()
	const raiseError = useRaiseError()
	const [showPasswordValidation, setShowPasswordValidation] = useState(false)
	const {
		data: {
			newPasswordPageTitle,
			buttonResetPassword,
			placeholderPassword,
			placeholderPasswordRepeat,
			errorInputMissingPasswordRepeat,
			errorInputMustBeTheSamePasswordRepeat,
			errorInputMissingPassword,
			errorInputPwRequirement,
		},
	} = useGetStrings(undefined, { defaultData: {} })
	const [newPassword, result] = useNewPassword()
	const {
		register,
		handleSubmit,
		getValues,
		trigger,
		formState: { errors },
		watch,
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
			password: "",
			passwordConfirm: "",
		},
	})

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const submit = useCallback(async () => {
		handleSubmit(async data => {
			try {
				await newPassword({ newPassword: data.password, resetPasswordToken }).unwrap()
				replace("/login?action=savedPassword", AnimationTypes.stack, null, "pop")
			} catch (e) {
				raiseError(e)
			}
		})()
	})

	return (
		<AnimatedRoute className="h-100">
			<ImagePage>
				<ContentHeader
					canGoBack
					colorStyle="white"
					animation="stack"
					customReturnFunction={() => {
						replace("/login")
					}}
				>
					{newPasswordPageTitle}
				</ContentHeader>
				<ContentBody className="container-md f4 mt-6">
					<form>
						<Input
							name="password"
							type="password"
							label={placeholderPassword + "*"}
							onFocusChange={isFocused => {
								setShowPasswordValidation(isFocused)
							}}
							formRegister={register("password", {
								required: {
									value: true,
									message: errorInputMissingPassword,
								},
								validate: () => {
									if (getValues("passwordConfirm").length) {
										trigger("passwordConfirm")
									}
									return true
								},
								pattern: {
									value: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
									message: errorInputPwRequirement,
								},
							})}
							className="primary"
						/>
						{showPasswordValidation && <PasswordValidation password={watch("password") || ""} />}

						<Input
							type="password"
							label={placeholderPasswordRepeat + "*"}
							autocomplete="off"
							formRegister={register("passwordConfirm", {
								required: {
									value: true,
									message: errorInputMissingPasswordRepeat,
								},
								validate: {
									equalsPassword: value => value === getValues().password || errorInputMustBeTheSamePasswordRepeat,
								},
							})}
							className="primary mt-3"
							errors={errors}
						/>
						<div className={"mt-4" + (sm || md ? " flex" : "")}>
							<Button style="primary" onClick={submit} fillWidth={sm || md} isLoading={result && result.isFetching}>
								{buttonResetPassword}
							</Button>
						</div>
					</form>
				</ContentBody>
			</ImagePage>
		</AnimatedRoute>
	)
}
export default NewPassword
